import { PanelRightClose, PanelRightOpen } from 'lucide-react';
import React from 'react';

import { NotesPanel } from '@/components/NotesPanel';
import { Button } from '@/components/ui/button';
import { SimpleTooltip } from '@/components/ui/tooltip';

interface NotesColumnProps {
  caseRecordId: string;
  canAddNote: boolean;
  isCollapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
}

/**
 * Right-side collapsible notes column for the case details page. Renders only
 * the notes panel — the previous tasks panel was removed deliberately.
 */
export const NotesColumn: React.FC<NotesColumnProps> = ({
  caseRecordId,
  canAddNote,
  isCollapsed,
  onCollapsedChange,
}) => {
  const width = isCollapsed ? 'w-10' : 'w-[360px]';

  return (
    <div className={`shrink-0 border-l flex transition-all duration-200 ${width}`}>
      {isCollapsed ? (
        <div className="flex flex-col items-center py-3 w-10 shrink-0">
          <SimpleTooltip content="Expand Notes" side="left">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onCollapsedChange(false)}
              className="h-6 w-6 p-0"
            >
              <PanelRightClose className="w-4 h-4" />
            </Button>
          </SimpleTooltip>
          <span className="text-xs text-muted-foreground mt-2 [writing-mode:vertical-lr] rotate-180">
            Notes
          </span>
        </div>
      ) : (
        <div className="flex-1 min-w-0 flex flex-col">
          <NotesPanel
            caseRecordId={caseRecordId}
            canAddNote={canAddNote}
            headerAction={
              <SimpleTooltip content="Collapse Notes" side="bottom">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onCollapsedChange(true)}
                  className="h-6 w-6 p-0"
                >
                  <PanelRightOpen className="w-4 h-4" />
                </Button>
              </SimpleTooltip>
            }
          />
        </div>
      )}
    </div>
  );
};
